import React, { useCallback, useEffect, useState } from "react";
import icon from "../../images/Icons/rfq.png";
import { useNavigate, useParams } from "react-router";
import axios from "axios";
import config from "../../config";
import NumberFormatter from "../../Component/NumberFormatter";
import { toast } from "react-toastify";
import useLogout from "../Auth/useLogout";
import NoData from "../../Component/NoData";
import Dataloader from "../../Component/Dataloader";
import { Link } from "react-router-dom";
import Loader from "../../Component/Loader";

export default function SellerQuotationDetail() {
  const params = useParams();
  const navigate = useNavigate();

  const logout = useLogout();
  const user = config.user;
  const userType = user ? user.type : "";
  const [loading, setLoading] = useState(false);
  const [exist, setExist] = useState(true);
  const [data, setData] = useState({
    product: {
      unique_id: "",
      category: "",
      product: "",
      brand: "",
      order_id: null,
      purpose: "",
      message: "",
      gst: "",
    },
    status: "",
    loading_address: [],
    delivery_by: "",
    variation: [],
    orderData: {
      basePrice: "",
      freight: "",
      total_quantity: "",
      total_ex_price: "",
      total_freight: "",
      total_price: "",
    },
    bidding_list: [],
    credit_days: 0,
    packaging_charge: null,
    quality: null,
    commission_type: "",
    commission: "",
    load_within: "",
  });

  const [, setFinalPrice] = useState("");
  const [message, setMessage] = useState("");
  const [basePrice, setBasePrice] = useState("");
  const [freight, setFreight] = useState("");
  const [variation, setVartiation] = useState([]);

  const [selectAddress, setSelectedAddress] = useState({
    id: null,
    address: [],
  });
  const [deliveryOption] = useState("biznie");
  const [price, setPrice] = useState([]);
  const [timeLeft, setTimeLeft] = useState(null);
  const [isTimeUp, setIsTimeUp] = useState(true);
  const [totalCommissionAmount, setTotalCommissionAmount] = useState(null);
  const handleMessage = (event) => {
    setMessage(event.target.value);
  };

  const handleBasePrice = (event) => {
    setBasePrice(event.target.value);
  };

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${config.apiUrl}/seller/product-enquiry/${params.id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: config.token,
            Accept: "application/json",
          },
        }
      );

      setBasePrice(response.data.data.base_price ?? "");
      setSelectedAddress({
        id: 0,
        address: response.data.data.loading_address[0] ?? "",
      });
      setFreight(response.data.data.transport_price ?? "");
      setVartiation(response.data.data.variation ?? "");

      setData((prevData) => ({
        ...prevData,
        product: {
          unique_id: response.data.data.unique_id,
          category: response.data.data.commodity_product.category.name,
          product: response.data.data.commodity_product.name,
          brand: response.data.data.brand.name,
          order_id: response.data.data.order_id,
          purpose: response.data.data.purpose,
          message: response.data.data.description,
          gst: response.data.data.gst,
        },
        status: response.data.data.status,
        loading_address: response.data.data.loading_address
          ? response.data.data.loading_address[0]
          : "",
        delivery_by: response.data.data.delivery_by,
        variation: response.data.data.variation,
        orderData: {
          basePrice: response.data.data.base_price,
          freight: response.data.data.transport_price,
          total_quantity: response.data.data.total_quantity,
          total_ex_price: response.data.data.ex_price,
          total_freight:
            +response.data.data.total_quantity *
            +response.data.data.transport_price,
          total_price: response.data.data.for_price,
        },
        // bidding_list: response.data.bidding_list,
        credit_days: response.data.data.credit_days,
        packaging_charge: response.data.data.selected_packaging_charge,
        quality: response.data.data.selected_quality,
        commission_type: response.data.data.commission_type,
        commission: response.data.data.commission,
        load_within: response.data.data.load_within,
      }));

      const createdAt = response.data.data.created_at;
      const replyMinutes = parseInt(response.data.reply_time);

      const createdAtDate = new Date(
        createdAt.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")
      );

      const deadline = new Date(createdAtDate.getTime() + replyMinutes * 60000);

      const interval = setInterval(() => {
        const now = new Date();
        const diff = deadline - now;

        if (diff <= 0) {
          setTimeLeft("00:00");
          setIsTimeUp(true);
          clearInterval(interval);
        } else {
          const minutes = String(Math.floor(diff / 60000)).padStart(2, "0");
          const seconds = String(Math.floor((diff % 60000) / 1000)).padStart(2, "0");
          setTimeLeft(`${minutes}:${seconds}`);
          setIsTimeUp(false);
        }
      }, 1000);

      return () => clearInterval(interval);

    } catch (error) {
      if (
        error.response &&
        (error.response.status === 404 ||
          error.response.status === 400 ||
          error.response.status === 500)
      ) {
        setExist(false);
      }
      if (error.response && error.response.status === 401) {
        logout();
      }
    } finally {
      setLoading(false);
    }
  }, [params.id, logout]);

  useEffect(() => {
    if (data.commission && data.product.gst) {
      const calculatedAmount = data.commission * (data.orderData.total_quantity + data.product.gst / 100);
      setTotalCommissionAmount(calculatedAmount);
    }
  }, [data]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    const calculateFinalPrice = () => {
      const finalExPrice = variation
        .map((data) => (+basePrice + +data.price) * +data.quantity)
        .reduce((acc, current) => acc + current, 0);

      const calculatePrice = variation.map((data) => data.price);

      var finalFreghtPrice = 0;
      if (freight > 0) {
        finalFreghtPrice = variation
          .map((data) => +freight * +data.quantity)
          .reduce((acc, current) => acc + current, 0);
      }

      setPrice(calculatePrice); //Price Updates
      setFinalPrice(+finalExPrice + +finalFreghtPrice); //To show final price
    };

    calculateFinalPrice();
  }, [basePrice, variation, deliveryOption, freight]);

  const updateToOrder = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(
        `${config.apiUrl}/seller/product-enquiry/${params.id}`,
        {
          base_price: basePrice,
          loading_address: [selectAddress.address],
          delivery_by: deliveryOption,
          price: price,
          transport_price: freight ? freight : null,
          variation: variation,
          description: message,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: config.token,
            Accept: "application/json",
          },
        }
      );

      toast.success(response.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      setTimeout(() => {
        setMessage("");
        navigate(`/seller-quotation-detail/${params.id}`);
      }, 1500);
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      if (error.response && error.response.status === 401) {
        logout();
      }
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 3000);
    }
  };

  const fetchBiddingList = useCallback(async () => {
    try {
      const biddingResponse = await axios.get(
        `${config.apiUrl}/seller/product-enquiry/${params.id}/bidding-list`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: config.token,
            Accept: "application/json",
          },
        }
      );

      setData((prevData) => ({
        ...prevData,
        bidding_list: biddingResponse.data.bidding_list,
      }));
    } catch (error) {
      if (error.response && error.response.status === 401) {
        logout();
      }
      console.error("Error fetching bidding list:", error);
    }
  }, [params.id, logout]);

  useEffect(() => {
    fetchBiddingList(); // Initial call
    const interval = setInterval(() => {
      fetchBiddingList();
    }, 10000); // 10 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, [fetchBiddingList]);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row-layout mrb1">
          {loading ? (
            <div className="d-flex justify-content-center">
              <Dataloader />
            </div>
          ) : (
            <>
              {exist ? (
                <form onSubmit={updateToOrder}>
                  <div className="row-hd-txt">
                    <div className="row-hd-txt-left">
                      <img src={icon} alt="icon" />
                      <h5>Seller Quotation Details</h5>
                    </div>
                    <div className="status-right">
                      <h6 className="status sent">{data.status}</h6>
                    </div>
                  </div>
                  <div className="row purchase-order-row g-3">
                    <div className="col-lg-4 col-md-6 px-2">
                      <div className="purchase-order-table">
                        <label className="order-label">Product Details</label>
                        <table className="table chart-table table-bordered m-0">
                          <tbody>
                            <tr>
                              <td>Quotation No:</td>
                              <td>{data.product.unique_id}</td>
                            </tr>
                            <tr>
                              <td>Category:</td>
                              <td>{data.product.category}</td>
                            </tr>
                            <tr>
                              <td>Brand:</td>
                              <td>{data.product.brand}</td>
                            </tr>
                            <tr>
                              <td>Product:</td>
                              <td>{data.product.product}</td>
                            </tr>
                            {data.quality && (
                              <tr>
                                <td>Quality:</td>
                                <td>{data.quality.name}</td>
                              </tr>
                            )}
                            {data.packaging_charge && (
                              <tr>
                                <td>Packaging:</td>
                                <td>
                                  {data.packaging_charge.name}
                                </td>
                              </tr>
                            )}
                            <tr>
                              <td>Purpose:</td>
                              <td>{data.product.purpose ?? "---"}</td>
                            </tr>
                            <tr>
                              <td>Message:</td>
                              <td>{data.product.message ?? "---"}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6 px-2">
                      <div className="purchase-order-table">
                        <label className="order-label">Loading Address</label>
                        <table className="table chart-table table-bordered m-0">
                          <tbody>
                            <tr>
                              <td>Address Line1:</td>
                              <td>{data.loading_address.address_line_one}</td>
                            </tr>
                            <tr>
                              <td>Address Line2:</td>
                              <td>{data.loading_address.address_line_two}</td>
                            </tr>
                            <tr>
                              <td>City:</td>
                              <td>{data.loading_address.city}</td>
                            </tr>
                            <tr>
                              <td>State:</td>
                              <td>{data.loading_address.state}</td>
                            </tr>
                            <tr>
                              <td>Pincode:</td>
                              <td>{data.loading_address.pin_code}</td>
                            </tr>
                          </tbody>
                        </table>
                        {/* <label className="order-label">
                          Product Delivery By
                        </label>
                        <p className="text-capital">
                          {data.delivery_by ?? "Biznie"}
                        </p> */}
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6 px-2">
                      <div className="purchase-order-table">
                        <label className="order-label">Estimate Price</label>
                        <div className="table-responsive">
                          <table className="table chart-table table-bordered m-0">
                            <thead>
                              <tr>
                                <th>Requirements</th>
                                <th>Ex Price</th>
                                <th>Ex Price x Qty</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data.variation.map((vardata, index) => (
                                <tr key={index}>
                                  <td className="fw-normal">
                                    {vardata.value[0].value}
                                    {vardata.value[0].unit.short_name} -{" "}
                                    {vardata.quantity}
                                    MT
                                  </td>
                                  <td>
                                    Rs{" "}
                                    <NumberFormatter
                                      number={vardata.per_unit_price}
                                    />
                                    /MT
                                  </td>
                                  <td>
                                    Rs{" "}
                                    <NumberFormatter
                                      number={vardata.final_price}
                                    />
                                  </td>
                                </tr>
                              ))}
                              <tr>
                                <td colSpan="2" className="text-start fw-bold">
                                  Total Ex Price:
                                </td>
                                <td className="fw-bold">
                                  Rs{" "}
                                  <NumberFormatter
                                    number={data.orderData.total_ex_price}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 px-2">
                      <div className="purchase-order-table card-shadow bg-primary-gradient">
                        <label className="order-label">Order Details</label>
                        <table>
                          <tbody>
                            <tr>
                              <td>Basic Price:</td>
                                <td className="text-success animate-price fs-4">
                                  Rs{" "}
                                  <NumberFormatter
                                    number={data.orderData.basePrice}
                                  />
                              </td>
                            </tr>
                            <tr>
                              <td>Total Quantity:</td>
                              <td>{data.orderData.total_quantity}MT</td>
                            </tr>
                            <tr>
                              <td>Dispatch Within:</td>
                              <td>{data.load_within ? data.load_within + " Days" : ""}</td>
                            </tr>
                            {data.credit_days > 0 && (
                              <tr>
                                <td>Credit Days:</td>
                                <td>
                                  {data.credit_days} Days
                                </td>
                              </tr>
                            )}
                            {/* <tr>
                              <td>Total Ex-Factory:</td>
                              <td>
                                Rs{" "}
                                <NumberFormatter
                                  number={data.orderData.total_ex_price}
                                />
                              </td>
                            </tr> */}
                            {data.commission_type === "include" && (
                              <tr>
                                <td>
                                  Commission:
                                  <small><br />(Included)</small>
                                </td>
                                <td>
                                  Rs{" "}
                                  <NumberFormatter
                                    number={totalCommissionAmount}
                                  />
                                  {" "} ( <NumberFormatter
                                    number={data.commission}
                                  /> / MT )
                                  <small><br />({data.product.gst}% GST)</small>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        <p className="price-note text-bill">
                          {" "}
                          Seller shall be fully reponsible for the quality of goods supplied.
                        </p>
                        {/* {data.credit_days > 0 && (
                          <p className="price-note pb-1 mb-1">
                            The credit period starts form the date the invoice is generated.
                          </p>
                        )} */}
                        {userType !== "seller" && (
                          <>
                            <table>
                              <tbody>
                                <tr>
                                  <td>Freight:</td>
                                  <td>
                                    Rs{" "}
                                    <NumberFormatter
                                      number={data.orderData.freight}
                                    />
                                    /MT
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    Total Freight
                                    <small>(Freight * Total Quantity)</small>:
                                  </td>
                                  <td>
                                    Rs{" "}
                                    <NumberFormatter
                                      number={data.orderData.total_freight}
                                    />
                                    /MT
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <p className="price-note border-bottom pb-1 mb-1">
                              {" "}
                              Freight may change +/- 100. (Freight depends on demand
                              & supply of trucks on loading day)
                            </p>

                            <table>
                              <tbody>
                                <tr>
                                  <td>
                                    Total Amount Payable
                                    <small>(Ex-Factory + Freight)</small>:
                                  </td>
                                  <td>
                                    Rs{" "}
                                    <NumberFormatter
                                      number={data.orderData.total_price}
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <p className="price-note">
                              Disclaimer: The invoice amount will be updated after
                              the goods are loaded and the final quantity is
                              confirmed. {data.status}
                            </p>
                          </>
                        )}


                        {data.product.order_id && data.status === "ordered" && (
                          <div className="mt-2 mb-1">
                            <Link
                              to={`/seller-order-detail/${data.product.order_id}`}
                              className="submit_btn bg-warning"
                            >
                              Go to order
                            </Link>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6 mt-1 order-2 order-sm-1">
                      <div className="purchase-order-table">
                        <label className="order-label">
                          Other Seller's Basic Price <br />
                          <small className="text-danger">
                            Preference will be given to the lowest price.
                          </small>
                        </label>
                        <div className="table-responsive">
                          <table className="table chart-table table-bordered m-0">
                            <thead>
                              <tr>
                                <th>Seller</th>
                                <th>Basic Price</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data.bidding_list?.length > 0 ? (
                                data.bidding_list.map((item, index) => (
                                  <tr key={index}>
                                    <td>
                                      Seller {index + 1}
                                      {item.is_my_price && (
                                        <span className="badge rounded-pill bg-danger ms-3">My Offer</span>
                                      )}
                                    </td>
                                    <td>
                                      Rs{" "}
                                      <NumberFormatter
                                        number={item.base_price}
                                      />
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="2" className="text-center">
                                    No Data Found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12 order-1 order-sm-2">
                      {/* Show update form only when time is not up and there is no order created */}
                      {!isTimeUp && !data.product.order_id ? (
                        <div className="row mt-3">
                          <div className="col-lg-6">
                            <div className="purchase-order-table border-0">
                              <label
                                htmlFor="base_price"
                                className="fw-normal"
                              >
                                Basic Price
                              </label>
                              <input
                                type="number"
                                className="form-control"
                                name="base_price"
                                id="base_price"
                                value={basePrice}
                                onChange={handleBasePrice}
                                placeholder="Enter current price"
                              />
                              <span className="text-danger"> Please enter or change current price. </span>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="purchase-order-table border-0">
                              <label htmlFor="message" className="form-label">
                                Write Your Message
                              </label>
                              <textarea
                                className="form-control"
                                rows="1"
                                name="message"
                                id="message"
                                value={message}
                                onChange={handleMessage}
                                placeholder="Write your message"
                              ></textarea>
                              <div className="text-end mt-2">
                                {timeLeft && !isTimeUp && (
                                  <span className="text-danger mt-1 me-5">⏳ Time Remaining: {timeLeft}</span>
                                )}
                                <button
                                  type="submit"
                                  className="booking-btn"
                                  title="Book Now"
                                  disabled={loading}
                                >
                                  {loading ? <Loader /> : "Submit"}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="row mt-3">
                          <div className="col-lg-12">
                            <div className="purchase-order-table border-0 p-3">
                              {isTimeUp ? (
                                <div className="alert alert-danger d-flex align-items-start mb-0" role="alert">
                                  <div style={{ fontSize: "22px", marginRight: "12px" }}>⏳</div>
                                  <div>
                                    <strong>Update Period Ended</strong>
                                    <div className="small">Time to update prices has expired. You can no longer submit price updates for this quotation.</div>
                                  </div>
                                </div>
                              ) : data.product.order_id && data.status === "ordered" ? (
                                <div className="alert alert-secondary d-flex align-items-start justify-content-between mb-0" role="alert">
                                  <div className="d-flex align-items-start">
                                    <div style={{ fontSize: "22px", marginRight: "12px" }}>🔒</div>
                                    <div>
                                      <strong>Updates Disabled</strong>
                                      <div className="small">Price update is disabled because an order has been created.</div>
                                    </div>
                                  </div>
                                  {data.product.order_id && data.status === "ordered" && (
                                    <div className="ms-3">
                                      <Link to={`/seller-order-detail/${data.product.order_id}`} className="btn btn-sm btn-outline-warning">View Order</Link>
                                    </div>
                                  )}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </form>
              ) : (
                <NoData />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
